import type { KeyboardEvent } from 'react'

// A list row that opens its record when clicked has to open it from the keyboard too: the row takes focus and Enter or
// Space open it. Keys pressed inside a control in the row (its checkbox, a menu button) are that control's, so only a
// key pressed on the row itself opens it. Spread the result onto the row:  <tr {...openableRow(() => open(id))}>
export function openableRow(open: () => void) {
  return {
    tabIndex: 0,
    onClick: open,
    onKeyDown: (e: KeyboardEvent<HTMLElement>) => {
      if (e.target !== e.currentTarget) return
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        open()
      }
    },
  }
}
